import { hFetch } from '@/lib/hfetch';
import type { PipelineReviewContactConfigurationEntity } from '@/api/entity_types/pipeline_review/ContactConfiguration';

export type PaginatedContactConfigurations = {
  records: PipelineReviewContactConfigurationEntity[];
  total: number;
  start_entry: number;
  end_entry: number;
  eligible_reviewer_filters: { id: number; name: string; email: string }[];
};

export const getContactConfigurations = async (params?: {
  sort?: string;
  order?: string;
  page?: number;
  reviewer?: string;
  search?: string;
}) => {
  const searchParams = new URLSearchParams();
  if (params?.sort) searchParams.set('sort', params.sort);
  if (params?.order) searchParams.set('order', params.order);
  if (params?.page) searchParams.set('page', String(params.page));
  if (params?.reviewer && params.reviewer !== 'All') searchParams.set('reviewer', params.reviewer);
  if (params?.search) searchParams.set('search', params.search);

  const query = searchParams.toString();
  return await hFetch<PaginatedContactConfigurations>({
    url: `/api/pipeline_review/contact_configurations${query ? `?${query}` : ''}`,
  });
};

export const updateContactConfiguration = async (
  id: number,
  params: Partial<PipelineReviewContactConfigurationEntity>
) => {
  return await hFetch({
    url: `/api/pipeline_review/contact_configurations/${id}`,
    method: 'PUT',
    payload: { pipeline_review_contact_configuration: params },
  });
};
